module.exports = __webpack_public_path__ + "static/works-lodg-dashboard-e273c035a0a631b8a3b109f0837af3f3.png";